<div class="containerClass">
<div class="row firstRow">
    <div class="col-md-3" style="padding: 2px"> 
        <mat-card class="firstRow generation-card">
            <mat-card-header>Connection Status</mat-card-header>
            <mat-card-content>
                <div style="height: 20vh;" id="deviceStatus"></div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-5" style="padding: 2px"> 
      <mat-card class="generation-card">
        <mat-card-header>
         Generation (kWh)
        </mat-card-header>
        <mat-card-content>
          <div class="generation-grid">
            <div class="grid-item" *ngFor="let item of generationStats">
              <div class="value">{{ item.value | number }}</div>
              <div class="label">{{ item.label }}</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>                
    </div>
    <div class="col-md-4" style="padding: 2px"> 
      <!--<div class="button-row" style="display: flex;justify-content: space-between;">
       <button class="btn alert-btn">🚨 Alerts</button>
        <button class="btn report-btn">📊 Reports</button>
        <button class="btn analytics-btn">📊 Analytics</button>
        <button class="btn settings-btn">⚙️ Settings</button>
      </div>      -->
      <div class="row weather-row">
        <div class="col-md-12">
          <mat-card class="weather-card-grid">
            <div class="weather-wrapper">
              <!-- Left: Temperature & Icon -->
              <div class="weather-temp">
                <div [ngSwitch]="weatherData?.weather">
                  <mat-icon
                    *ngSwitchCase="'Sky'"
                    class="weather-icon sunny"
                  >wb_sunny</mat-icon>
                
                  <mat-icon
                    *ngSwitchCase="'Clouds'"
                    class="weather-icon cloudy"
                  >cloud</mat-icon>
                
                  <mat-icon
                    *ngSwitchCase="'Rain'"
                    class="weather-icon rain">rainy</mat-icon>
                
                  <mat-icon
                    *ngSwitchCase="'Snow'"
                    class="weather-icon snow"
                  >ac_unit</mat-icon>
                  <mat-icon
                  *ngSwitchDefault
                  class="weather-icon default"
                >wb_cloudy</mat-icon>
                </div>                
                <div class="temp-text">{{weatherData?.temperature || 0}}</div>
                <div class="condition-text">{{weatherData?.condition || 0}}</div>
              </div>
      
              <!-- Right: Weather Details in Fixed 2x3 Grid -->
              <div class="weather-details">
                <div class="detail-item">
                  <span>☀️ Sunrise:</span> {{weatherData?.sunrise || 0}}
                </div>
                <div class="detail-item">
                  <span>🌇 Sunset:</span>  {{weatherData?.sunset || 0}}
                </div>
                <div class="detail-item">
                  <span>💨 Wind:</span> {{weatherData?.wind || 0}}
                </div>
                <div class="detail-item">
                  <span>🌊Sea Level :</span> {{weatherData?.sea_level || 0}}
                </div>
                <div class="detail-item">
                  <span>🏔️GroundLevel:</span> {{weatherData?.grnd_level || 0}}
                </div>
                <div class="detail-item">
                  <span>💧 Humidity:</span> {{weatherData?.humidity || 0}}
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
                 
    </div>
</div>
  <div class="row secondRow">
    <div class="col-md-7" style="padding: 2px">
      <mat-card class="chart-card">
        <mat-card-header class="chart-card-header">
          <mat-card-title class="chart-title">Generation</mat-card-title>
          <div class="chart-buttons">
            <button
              class="chart-btn"
              [ngClass]="{ active: selectedFilter === 'daily' }"
              (click)="onFilterSelect('daily')"
            >
              Daily
            </button>
      
            <button
              class="chart-btn"
              [ngClass]="{ active: selectedFilter === 'weekly' }"
              (click)="onFilterSelect('weekly')"
            >
              Weekly
            </button>
      
            <button
              class="chart-btn"
              [ngClass]="{ active: selectedFilter === 'monthly' }"
              (click)="onFilterSelect('monthly')"
            >
              Monthly
            </button>
          </div>
        </mat-card-header>
      
        <mat-card-content>
          <div id="barChart" style="width: 100%; height: 22vh"></div>
        </mat-card-content>
      </mat-card>           
    </div>
    <!--<div class="col-md-3" style="padding: 2px">
      <mat-card class="energy-card-content">
        <mat-card-header class="top-row">
          Energy Summary
          <span class="spacer"></span>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>filter_list</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="selectDuration('Today')">Today</button>
            <button mat-menu-item (click)="selectDuration('Yesterday')">Yesterday</button>
            <button mat-menu-item (click)="selectDuration('This Week')">This Week</button>
            <button mat-menu-item (click)="selectDuration('This Month')">This Month</button>
            <button mat-menu-item (click)="selectDuration('Last Month')">Last Month</button>
          </mat-menu>
        </mat-card-header>
      
        <mat-card-content>
          <div class="energy-section actual">
            <div class="label">Actual</div>
            <div class="value">{{actualData}}<span class="unit">kWh</span></div>
          </div>
      
          <div class="energy-section expected">
            <div class="label">Expected</div>
            <div class="value">{{expectedData}} <span class="unit">kWh</span></div>
          </div>
      
          <div class="energy-section loss">
            <div class="label">Loss</div>
            <div class="value">{{loss}} <span class="unit">kWh</span></div>
          </div>
        </mat-card-content>
      </mat-card>      
  </div> -->
  <div class="col-md-5 h-100" style="padding: 2px">
    <mat-card class="asset-mat-card">
      <mat-card-header style="font-weight: bold;">
        Individual Asset Generation
      </mat-card-header>
      <mat-card-content class="asset-scroll-container">
        <div class="asset-card" *ngFor="let asset of assetsData">
          <div class="asset-header">
            <span class="asset-id">{{ asset.assetid }}</span>
            <span class="asset-name">({{ asset.asset_name }})</span>
            
            <!-- New Feature: Growth/Loss Animation
            <span class="asset-change" [ngClass]="{
                'loss': asset.Last_Month_Loss_Percent > 0 || asset.This_Month_Loss_Percent > 0 || asset.Today_Loss_Percent > 0
              }">
              <span *ngIf="asset.Last_Month_Loss_Percent > 0" class="loss">📉 Last Month: {{ asset.Last_Month_KWH }}</span> -->
              <!-- <span *ngIf="asset.Last_Month_Loss_Percent > 0" class="growth">📈 Last Month: {{ asset.Last_Month_Loss_Percent }}%</span>
  
              <span *ngIf="asset.This_Month_Loss_Percent > 0" class="loss">📉 This Month: {{ asset.This_Month_Loss_Percent }}%</span> -->
              <!--<span *ngIf="asset.This_Month_Loss_Percent > 0" class="growth">📈 This Month: {{ asset.This_Month_Loss_Percent }}%</span>-->
  
              <!--<span *ngIf="asset.Today_Loss_Percent > 0" class="loss">📉 Today: {{ asset.Today_Loss_Percent }}%</span>
              <span *ngIf="asset.Today_Loss_Percent > 0" class="growth">📈 Today: {{ asset.Today_Loss_Percent }}%</span>
            </span> -->
          </div>
  
          <div class="asset-values-row">
            <div class="value total">
              Last Month: <span class="kwh">{{ asset.Last_Month_KWH  | number }} kWh</span>
            </div>
            <div class="value month">
              This Month: <span class="kwh">{{ asset.This_Month_KWH | number }} kWh</span>
            </div>
            <div class="value today">
              Today: <span class="kwh">{{ asset.Today_KWH | number }} kWh</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div class="row thirdRow">
  <div class="col-md-3 h-100" style="padding: 2px">
    <mat-card class="co2-card">
     
      <mat-card-content>
        Current Month
        <div class="co2-header">CO₂ Emission Reduction </div>
  
        <div class="co2-main-value">
          <span class="co2-number">{{ co2Data.co2Kg |  number: '1.2-2'  }}</span>
          <span class="co2-unit">lbs CO₂ avoided</span>
        </div>
  
        <div class="co2-insights">
          <div class="insight">
            🌳 <span class="label">Trees Planted:</span>
            <span class="value">{{ co2Data.treesPlanted |  number: '1.2-2'  }}</span>
          </div>
          <div class="insight">
            🚗 <span class="label">Car Miles Offset:</span>
            <span class="value">{{ co2Data.milesOffset | number: '1.2-2'  }}</span>
          </div>
          <div class="insight">
            🏠 <span class="label">Homes Powered:</span>
            <span class="value">{{ co2Data.homesPowered | number: '1.2-2'  }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>  
  <div class="col-md-6 h-100" style="padding: 2px">
    <mat-card style="margin-top: 10px;">
      <mat-card-header class="chart-card-header">
        <mat-card-title class="chart-title">Performance Trend</mat-card-title>
       <!-- <div class="chart-buttons">
          <button
            class="chart-btn"
            [ngClass]="{ active: selectedFilterPerformance === 'daily' }"
            (click)="onFilterSelecPerformancet('daily')"
          >
            Daily
          </button>
    
          <button
            class="chart-btn"
            [ngClass]="{ active: selectedFilterPerformance === 'weekly' }"
            (click)="onFilterSelecPerformancet('weekly')"
          >
            Weekly
          </button>
    
          <button
            class="chart-btn"
            [ngClass]="{ active: selectedFilterPerformance === 'monthly' }"
            (click)="onFilterSelecPerformancet('monthly')"
          >
            Monthly
          </button>
        </div>-->
      </mat-card-header>
      <mat-card-content>
        <div style="height: 25vh;" id="performanceDegradation"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-3 h-100 px-1">
  <mat-card class="pricing-card">
    <mat-card-content>
     <!-- <div class="section-header">
        <div class="title">Unit Pricing Calculator</div>
      </div>

      <mat-form-field appearance="fill" class="w-100 unit-input">
        <mat-label>Unit Price (₹/unit)</mat-label>
        <input matInput type="number" [(ngModel)]="unitPrice" (input)="calculateTotal()" />
      </mat-form-field>

      <mat-tab-group [(selectedIndex)]="selectedTab" (selectedIndexChange)="calculateTotal()" class="tab-group">
        <mat-tab label="Today"></mat-tab>
        <mat-tab label="Yesterday"></mat-tab>
        <mat-tab label="This Week"></mat-tab>
        <mat-tab label="This Month"></mat-tab>
        <mat-tab label="Last Month"></mat-tab>
      </mat-tab-group>

      <div class="result-block">
        <div class="label">Total Energy</div>
        <div class="value">{{ currentKwh | number }} kWh ({{ (currentKwh / 1000) | number:'1.2-2' }} units)</div>

        <div class="label mt-2">Total Cost</div>
        <div class="value total-price">₹ {{ totalPrice | number:'1.2-2' }}</div>
      </div>-->
      <div class="calendar">
        <div class="calendar-header">
          <span class="arrow" (click)="prevMonth()">&#8592;</span>
          <div class="calendar-title">{{ monthName }} {{ currentYear }}</div>
          <span class="arrow" (click)="nextMonth()">&#8594;</span>
        </div>
      
        <div class="calendar-weekdays">
          <div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>
        </div>
      
        <div class="calendar-grid">
          <ng-container *ngFor="let day of calendarDays">
            <div
              class="calendar-day-cell"
              [class.empty]="!day.day"
              [class.bg-high]="day.colorClass === 'bg-high'"
              [class.bg-medium]="day.colorClass === 'bg-medium'"
              [class.bg-low]="day.colorClass === 'bg-low'"
            >
              <div class="date-number" *ngIf="day.day">{{ day.day }}</div>
              <div class="kwh-value" *ngIf="day.kwh !== undefined">{{ day.kwh.toFixed(1) }}</div>
            </div>
          </ng-container>
        </div>
      </div>      
    </mat-card-content>
  </mat-card>
</div>

</div>
